import { TExperimentsState } from '../../types/experiments';
import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState): TExperimentsState => state.experiments;
